import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";

import { fetchAppConfig } from "../config/appConfig";
import { buildNewRelicOptions } from "./newRelicConfig";
import { validateNewRelicConfig } from "./validateNewRelicConfig";

let browserAgent: BrowserAgent | null = null;

export const getBrowserAgent = (): BrowserAgent | null => browserAgent;

const initNewRelicBrowser = async (): Promise<void> => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const config = await fetchAppConfig();
    const validation = validateNewRelicConfig(config);

    if (!validation.shouldInitialize) {
      if (validation.missingFields.length > 0) {
        console.warn(
          "[New Relic] Browser monitoring is enabled but missing required config:",
          validation.missingFields.join(", ")
        );
      }

      return;
    }

    const options = buildNewRelicOptions(config);
    browserAgent = new BrowserAgent(options);
  } catch (error) {
    console.warn("[New Relic] Failed to initialize browser monitoring:", error);
  }
};

void initNewRelicBrowser();
